import Vue from 'vue'
import Router from 'vue-router'
import routes from './router'
// import {getUser} from '../service/service'
Vue.use(Router)

const router = new Router({
  routes: routes,
  mode: 'hash'
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token') || sessionStorage.getItem('token')
  if (!token && (to.name !== 'login')) {
    next({
      name: 'login'
    })
  }else if(token && (to.name !== 'login')){
    // let p = {
    //   UserUID: token
    // }
    // getUser(p).then(res=>{
    //   console.log(res)
    //   let userInfoif = res.User
    //   // if(res.Success){
    //   //   this.userInfo = res.User
    //   // }
    //   // if(name === 'index'){
    //   //   next({
    //   //     name: '/corporation/'
    //   //   })
    //   // }else{
    //   //   next()
    //   // }
    // })
    if(to.name === 'corporation-index'){
      next({
        name: 'corporation-automatic'
      })
    }else if(to.name === 'physician-index'){
      next({
        name: 'physician-automatic'
      })
    }else if(to.name === 'imagingEngineer-index'){
      next({
        name: 'imagingEngineer-custom'
      })
    }else if(to.name === 'salesRep-index'){
      next({
        name: 'salesRep-automatic'
      })
    }else{
      next({})
    }
  }else{
    next({})
  }
})

export default router
